<template>
    <hh-msg-display class="no-service-scheme-msg">
        Your address is not serviced by {{ (this.showSchemeTitle ? this.scheme.title : 'any scheme') }} at this time. <a class="no-service-scheme-msg__link" :href="this.scheme.registerInterestAt" target="_blank">Click here to register your interest</a> and we will let you know when there is a Plan Builder scheme covering your property.
    </hh-msg-display>
</template>

<script>

export default {

    props: {
        showSchemeTitle: {
            type: Boolean,
            default: true,
        },
    },

    computed: {

        /**
         * @returns {Scheme}
         */
        scheme() {
            return this.$scheme
        },
    },
}
</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\app-core\_no-service-scheme-msg.scss

</style>

